import { render, staticRenderFns } from "./TrademarkNiceClassList.vue?vue&type=template&id=fe1516d4&"
import script from "./TrademarkNiceClassList.vue?vue&type=script&lang=js&"
export * from "./TrademarkNiceClassList.vue?vue&type=script&lang=js&"
import style0 from "./TrademarkNiceClassList.vue?vue&type=style&index=0&id=fe1516d4&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports